import { render } from "./BorderLine.vue?vue&type=template&id=1430bedc&scoped=true&ts=true"
import script from "./BorderLine.vue?vue&type=script&lang=ts"
export * from "./BorderLine.vue?vue&type=script&lang=ts"

import "./BorderLine.vue?vue&type=style&index=0&id=1430bedc&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1430bedc"]])

export default __exports__